import { api } from './client';

/** Bank Reconciliation: statements uploaded through a column mapping, bank dates, the BRS. */
const B = '/accounts/books/brs';

export interface BankMapping {
  date: string; description: string; ref?: string | null; valueDate?: string | null; balance?: string | null;
  mode: 'split' | 'single'; debit?: string | null; credit?: string | null; amount?: string | null; drcr?: string | null;
  dateOrder: 'DMY' | 'MDY' | 'YMD';
}
export interface BrsBank { id: number; name: string; mapped: boolean; uploads: number; statementTo: string | null }
export interface BrsRow {
  voucherId: number; date: string; voucherNo: string; type: string; particulars: string; mode: string | null; refNo: string | null; instrDate: string | null;
  amount: number; bankDate: string | null; lineId: number | null; cleared: boolean;
}
export interface BrsLine { id: number; date: string; valueDate: string | null; description: string; refNo: string | null; amount: number }
export interface BrsScreen {
  ledger: { id: number; name: string }; from: string; to: string; books: number; rows: BrsRow[]; bankOnly: BrsLine[];
  notInBank: { dr: number; cr: number }; notInBooks: { dr: number; cr: number }; bank: number;
  statement: { date: string; balance: number; difference: number } | null; uploads: number;
}
export interface BrsUpload { id: number; fileName: string; rows: number; duplicates: number; from: string | null; to: string | null; uploadedBy: string | null; uploadedAt: string }

export const getBrsBanks = () => api.get<BrsBank[]>(`${B}/banks`).then((r) => r.data);
export const getBrs = (q: { ledger: number; from: string; to: string; all: boolean }) => api.get<BrsScreen>(B, { params: q }).then((r) => r.data);
export const getBrsUploads = (ledger: number) => api.get<BrsUpload[]>(`${B}/uploads`, { params: { ledger } }).then((r) => r.data);
const form = (file: File, ledgerId: number, mapping?: BankMapping) => {
  const fd = new FormData();
  fd.append('file', file);
  fd.append('ledgerId', String(ledgerId));
  if (mapping) fd.append('mapping', JSON.stringify(mapping));
  return fd;
};
export const previewStatement = (file: File, ledgerId: number) =>
  api.post<{ headerRow: number; headers: string[]; sample: string[][]; mapping: Partial<BankMapping>; fromSaved: boolean }>(`${B}/preview`, form(file, ledgerId)).then((r) => r.data);
export const importStatement = (file: File, ledgerId: number, mapping: BankMapping) =>
  api.post<{ uploadId: number | null; added: number; duplicates: number; matched: number; skipped: number; from: string; to: string }>(`${B}/import`, form(file, ledgerId, mapping)).then((r) => r.data);
export const deleteStatement = (id: number) => api.delete<{ ok: true; cleared: number }>(`${B}/uploads/${id}`).then((r) => r.data);
export const deleteStatementLine = (id: number) => api.delete(`${B}/lines/${id}`).then((r) => r.data);
export const rematchBank = (ledgerId: number) => api.post<{ matched: number }>(`${B}/match`, { ledgerId }).then((r) => r.data);
export const setBankDate = (b: { ledgerId: number; voucherId: number; bankDate?: string; lineId?: number }) => api.post(`${B}/reconcile`, b).then((r) => r.data);
export const clearBankDate = (ledgerId: number, voucherId: number) => api.delete(`${B}/reconcile/${voucherId}`, { params: { ledger: ledgerId } }).then((r) => r.data);
